import { createI18n } from 'vue-i18n';
import messages from './locales/messages.json';

const i18n = createI18n({
    locale: 'me',
    fallbackLocale: 'en',
    messages,
});

export default i18n;
